module.exports = __webpack_public_path__ + "static/media/pp-1.0a5dcdae.jpg";